import { render, staticRenderFns } from "./SettingTwoToneIcon.vue?vue&type=template&id=3b1fb042&scoped=true"
import script from "./SettingTwoToneIcon.vue?vue&type=script&lang=js"
export * from "./SettingTwoToneIcon.vue?vue&type=script&lang=js"
import style0 from "./SettingTwoToneIcon.vue?vue&type=style&index=0&id=3b1fb042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fb042",
  null
  
)

export default component.exports